import {NgModule} from '@angular/core';
import {OptixLibComponent} from './optix-lib.component';
import {OptixCalendarModule} from './app/optix-calendar/optix-calendar.module';
import {HttpClientModule} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {TranslateModule} from '@ngx-translate/core';
import {CommonModule} from '@angular/common';


@NgModule({
  declarations: [OptixLibComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    BrowserAnimationsModule,
    TranslateModule
  ],
  exports: [OptixLibComponent]
})
export class OptixLibModule {
}
